module.exports = __webpack_public_path__ + "static/media/unnamed.afdc821e.png";